document.addEventListener('click', function(event) {
  const summary = event.target.closest('summary[data-follow-link]');
  
  if (summary) {
    const details = summary.closest('details');
    
    if (details && details.hasAttribute('open')) {
      const url = summary.getAttribute('data-follow-link');
      if (url) {
        event.stopImmediatePropagation();
        event.preventDefault();
        
        try {
          const targetUrl = new URL(url, window.location.origin);
          if (targetUrl.hostname !== window.location.hostname) {
            window.open(url, '_blank', 'noopener,noreferrer');
          } else {
            window.location.href = url;
          }
        } catch (error) {
          window.location.href = url;
        }
      }
    }
  }
}, true);

(function() {
  const currentHost = window.location.hostname;

  function processLink(link) {
    if (link.hasAttribute('target')) return;
    const href = link.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('javascript:') || href.startsWith('mailto:') || href.startsWith('tel:')) return;

    try {
      const url = new URL(href, window.location.origin);
      if (url.hostname && url.hostname !== currentHost) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
    } catch (e) {
      console.warn('URLの解析中にエラーが発生しました。リンクの形式をご確認ください:', href, e);
    }
  }

  function processAllLinks(root) {
    const links = (root || document).querySelectorAll('a[href]');
    links.forEach(processLink);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { processAllLinks(); });
  } else {
    processAllLinks();
  }

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        if (node.tagName === 'A') {
          processLink(node);
        } else {
          processAllLinks(node);
        }
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();